// extracted by mini-css-extract-plugin
export default {"avatar-trigger":"MainMenu_avatar-trigger__H+MCe"};